import { ReportStatus } from "../../shared/interfaces/ReportStatus";

export type ConfirmationView =
  | { kind: "redirect" }
  | {
      kind: "view";
      title: string;
      body: string;
      showDownload: boolean;
      showEventNumber: boolean;
    };

// Copy relocated verbatim: the awaiting-CO body shipped via location.state
// from FinalEditsPage; the signed body was this page's default.
const AWAITING_CO_BODY =
  "Your report is signed and awaiting Commanding Officer review. You will be notified once it has been reviewed.";
const SIGNED_BODY =
  "Your police report is now signed and downloadable using the button below.";
const COMMITTED_BODY =
  "Your report has been submitted to your Records Management System (RMS) and is ready for download below.";

/**
 * Confirmation copy from the report's ACTUAL status (refresh-safe), instead
 * of a message frozen into navigation state. Unsigned statuses redirect —
 * there is nothing to confirm.
 */
export function confirmationViewForStatus(args: {
  reportStatus: string;
  coApprovalEnabled: boolean;
  eventNumber?: string | null;
}): ConfirmationView {
  const { reportStatus, coApprovalEnabled, eventNumber } = args;

  if (reportStatus === ReportStatus.RMS_COMMITTED) {
    return {
      kind: "view",
      title: "Report Submitted",
      body: COMMITTED_BODY,
      showDownload: true,
      showEventNumber: !!eventNumber,
    };
  }

  // Immediately after /report/sign under the CO workflow the server may
  // report SIGNED or IN_CO_REVIEW — both mean "held for CO review".
  if (
    coApprovalEnabled &&
    (reportStatus === ReportStatus.SIGNED ||
      reportStatus === ReportStatus.IN_CO_REVIEW)
  ) {
    return {
      kind: "view",
      title: "Report Submitted",
      body: AWAITING_CO_BODY,
      showDownload: true,
      showEventNumber: false,
    };
  }

  if (
    reportStatus === ReportStatus.SIGNED ||
    reportStatus === ReportStatus.CO_APPROVED
  ) {
    return {
      kind: "view",
      title: "Your Report is Ready",
      body: SIGNED_BODY,
      showDownload: true,
      showEventNumber: false,
    };
  }

  return { kind: "redirect" };
}
